<template>
  <div :class="['app-wrapper', showRightPanel ? '' : 'no-right-panel']">
    <NavigationVue ref="nav-panel" />
    <div class="main-container" ref="container">
      <CandidateImportTypeDialog
        v-if="
          is_visible.candidate_import_type_dialog &&
          dialogMetaData &&
          dialogMetaData.panels
        "
        :metaData="dialogMetaData"
        :is_visible="is_visible.candidate_import_type_dialog"
        @cancel-callback="closeDialog('candidate_import_type_dialog')"
      />
      <TableColumnsEditDialog
        v-if="is_visible.table_edit_dialog"
        :is_visible="is_visible.table_edit_dialog"
        :module="editTableColumnsOptions?.tableModule"
        :columnsParams="editTableColumnsOptions?.columnsParams"
        @close-popup="closeAndUpdate(false)"
        @close-update="closeAndUpdate(true)"
      />
      <CandidateImportDialog
        v-if="
          is_visible.candidate_import_dialog_single ||
          is_visible.candidate_import_dialog_multi
        "
        :is_visible="
          is_visible.candidate_import_dialog_single ||
          is_visible.candidate_import_dialog_multi
        "
        :mode="
          is_visible.candidate_import_dialog_single == true ? 'single' : 'multi'
        "
        @cancel-callback="
          closeDialog(
            is_visible.candidate_import_dialog_single == true
              ? 'candidate_import_dialog_single'
              : 'candidate_import_dialog_multi'
          )
        "
      />
      <SingleGeneralDialog
        v-if="dialogVisible && dialogMetaData && dialogMetaData.panels"
        :metaData="dialogMetaData"
      />
      <MassSaveResumeProgressDialog
        v-if="is_visible.mass_save_resume_progress_dialog"
        :is_visible="is_visible.mass_save_resume_progress_dialog"
      />
      <GeneralDialog
        v-if="is_visible.general_dialog.display"
        :is_visible="is_visible.general_dialog.display"
        @reset-callback="closeCurrentDialog('general_dialog')"
        @cancel-callback="closeCurrentDialog('general_dialog')"
        @change-stage="
          changeStage(is_visible.general_dialog.intents, 'general_dialog')
        "
      >
        <EventEditDialog
          :is_visible="true"
          :isDialog="false"
          :data="selectedEvent"
        />
      </GeneralDialog>
      <Dialog
        v-if="is_visible.stage_dialog.display"
        :is_visible="is_visible.stage_dialog.display"
        title="Перевод на этап"
        :text="`Вы действительно хотите сменить этап подбора на «${stageName}»?`"
        @ok-callback="
          changeStage(is_visible.stage_dialog.intents, 'stage_dialog')
        "
        @cancel-callback="closeCurrentDialog('stage_dialog')"
      />
      <Dialog
        v-if="is_visible.merge_dublicate_dialog"
        title="Объединить кандидатов?"
        text="При объединении дубликатов действие нельзя будет отменить"
        :is_visible="is_visible.merge_dublicate_dialog"
        button-ok-color="blue"
        button-cancel-color="darkBlue"
        @ok-callback="mergeDublicate"
        @cancel-callback="closeCurrentDialog('merge_dublicate_dialog')"
      />
      <CoordinationPlanDialog
        v-if="
          is_visible.plan_popup_detail &&
          dialogMetaData &&
          dialogMetaData.panels
        "
        :is_visible="is_visible.plan_popup_detail"
        :metaData="dialogMetaData"
        @cancel-callback="closeCurrentDialog('plan_popup_detail')"
      />
      <CoordinationPlanEditDialog
        v-if="
          is_visible.plan_popup_edit && dialogMetaData && dialogMetaData.panels
        "
        :is_visible="is_visible.plan_popup_edit"
        :fields="dialogMetaData.panels"
        :metaData="dialogMetaData"
        @cancel-callback="closeCurrentDialog('plan_popup_edit')"
      />
      <ConfirmCloseDialog
        v-if="is_visible.confirm_close_dialog.display"
        :is_visible="is_visible.confirm_close_dialog.display"
        @reset-callback="confirmCloseDialog(null, false)"
      />
      <router-view />
    </div>
    <RightPanel v-if="showRightPanel" />
    <Dialog
      v-if="is_visible.stage_dialog.display"
      :is_visible="is_visible.stage_dialog.display"
      title="Перевод на этап"
      :text="`Вы действительно хотите сменить этап подбора на «${stageName}»?`"
      @ok-callback="
        changeStage(is_visible.stage_dialog.intents, 'stage_dialog')
      "
      @cancel-callback="closeCurrentDialog('stage_dialog')"
    />
    <Dialog
      v-if="is_visible.merge_dublicate_dialog"
      title="Объединить кандидатов?"
      text="При объединении дубликатов действие нельзя будет отменить"
      :is_visible="is_visible.merge_dublicate_dialog"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="mergeDublicate"
      @cancel-callback="closeCurrentDialog('merge_dublicate_dialog')"
    />
    <CoordinationPlanDialog
      v-if="is_visible.plan_popup_detail"
      :is_visible="is_visible.plan_popup_detail"
      :metaData="dialogMetaData"
      @cancel-callback="closeCurrentDialog('plan_popup_detail')"
    />
    <CoordinationPlanEditDialog
      v-if="
        is_visible.plan_popup_edit && dialogMetaData && dialogMetaData.panels
      "
      :is_visible="is_visible.plan_popup_edit"
      :fields="dialogMetaData.panels"
      :metaData="dialogMetaData"
      @cancel-callback="closeCurrentDialog('plan_popup_edit')"
    />
    <ConfirmCloseDialog
      v-if="is_visible.confirm_close_dialog.display"
      :is_visible="is_visible.confirm_close_dialog.display"
      @reset-callback="confirmCloseDialog(null, false)"
    />
    <EventEditDialog
      v-if="is_visible.create_event_dialog_empty"
      :is_visible="is_visible.create_event_dialog_empty"
      :data="null"
      @reset-callback="
        {
          closeDialog('create_event_dialog_empty', null);
          selectedEvent = null;
        }
      "
      @confirm-close="p => confirmCloseDialog(p, true)"
    />
    <CommonDialog
      v-if="is_visible.document_dialog"
      :is_visible="is_visible.document_dialog"
      title="Удалить документ"
      text="Вы действительно хотите удалить этот документ?"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="deleteDocument"
      @cancel-callback="closeDialog('document_dialog')"
    >
    </CommonDialog>
    <AuthDialog
      v-if="visibleAuthForm"
      :is_visible="visibleAuthForm"
      :module="telegramModule"
      :session-id="sessionId"
      :user-id="userId"
      @close-popup="visibleAuthForm = false"
    />
    <PublicatorAuthDialog
      v-if="is_visible.publicator_auth_dialog"
      :is_visible="is_visible.publicator_auth_dialog"
      :needToImport="false"
      @reset-callback="checkAuth"
    />
    <EmailDialog
      v-if="is_visible.delete_event_dialog"
      :is_visible="is_visible.delete_event_dialog"
      :candidateId="deleteEventOptions.candidateId"
      title="Удалить встречу?"
      :confirmDeleteMeeting="true"
      @confirm="deleteEvent"
      :width="deleteEventOptions.deleteDialogWidth"
      @reset-callback="closeDeleteEventDialog"
    />
    <PushNotifications />
  </div>
</template>
<script>
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request.js';
import { store } from '@/store';
import { INTENT_AREA, MODULE, EVENTBUS_EVENTS } from '@/utils/constants';
import { dialogMixin, errorMsg, mixin, parseIntent } from '@/utils/mixins';
import CandidateImportDialog from 'Elements/Dialog/CandidateImportDialog';
import CandidateImportTypeDialog from 'Elements/Dialog/CandidateImportTypeDialog';
import ConfirmCloseDialog from 'Elements/Dialog/ConfirmCloseDialog';
import CoordinationPlanDialog from 'Elements/Dialog/CoordinationPlanDialog';
import CoordinationPlanEditDialog from 'Elements/Dialog/CoordinationPlanEditDialog';
import Dialog from 'Elements/Dialog/Dialog';
import EventEditDialog from 'Elements/Dialog/EventEditDialog';
import GeneralDialog from 'Elements/Dialog/GeneralDialog';
import MassSaveResumeProgressDialog from 'Elements/Dialog/MassSaveResumeProgressDialog';
import SingleGeneralDialog from 'Elements/Dialog/SingleGeneralDialog';
import NavigationVue from 'Elements/NavigationBar/Navigation';
import RightPanel from 'Elements/Panel/RightPanel';
import PushNotifications from 'Elements/Push/PushNotifications';
import TableColumnsEditDialog from 'Elements/Dialog/TableColumnsEditDialog';
import AuthDialog from 'Elements/Dialog/AuthTelegramDialog';
import CommonDialog from 'Elements/Dialog/CommonDialog';
import EmailDialog from 'Elements/Dialog/EmailDialog';
import PublicatorAuthDialog from 'Elements/Dialog/PublicatorAuthDialog';

export default {
  mixins: [mixin, dialogMixin, errorMsg, parseIntent],
  created() {
    eventBus.$on(EVENTBUS_EVENTS.ASK_TO_DELETE_DOCUMENT, () => {
      this.$set(this.is_visible, 'document_dialog', true);
    });
    eventBus.$on(
      EVENTBUS_EVENTS.ASK_TO_OPEN_TELEGRAM_DIALOG,
      ({ telegramModule, sessionId, userId }) => {
        this.telegramModule = telegramModule;
        this.sessionId = sessionId;
        this.userId = userId;
        this.visibleAuthForm = true;
      }
    );
    eventBus.$on(EVENTBUS_EVENTS.OPEN_DELETE_EVENT_DIALOG, options => {
      this.deleteEventOptions = options;
      this.$set(this.is_visible, 'delete_event_dialog', true);
    });
    eventBus.$on(EVENTBUS_EVENTS.OPEN_EDIT_COLUMNS_DIALOG, options => {
      this.editTableColumnsOptions = options;
      this.$set(this.is_visible, 'table_edit_dialog', true);
    });
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.ASK_TO_DELETE_DOCUMENT);
    eventBus.$off(EVENTBUS_EVENTS.ASK_TO_OPEN_TELEGRAM_DIALOG);
    eventBus.$off(EVENTBUS_EVENTS.OPEN_DELETE_EVENT_DIALOG);
    eventBus.$off(EVENTBUS_EVENTS.OPEN_EDIT_COLUMNS_DIALOG);
  },
  data() {
    return {
      resizeObserver: null,
      emptyWidth: null,
      rightPanelIsOpen: store.state.rightPanel.panelMode || false,
      navPanelIsOpen: false,
      telegramModule: '',
      sessionId: '',
      userId: '',
      visibleAuthForm: false,
      deleteEventOptions: null,
      editTableColumnsOptions: null
    };
  },
  mounted() {
    store.dispatch('auth/getUmamiAttr');
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(window.document.body);
    this.onResize();

    const rightPanelInitMode = localStorage.getItem('rightPanelMode');

    if (rightPanelInitMode !== 'null' && this.$route?.meta?.rightPanel) {
      store.commit('rightPanel/setParam', {
        name: 'panelMode',
        val: rightPanelInitMode
      });
    }
    if (!this.$route.meta?.changeableList) {
      localStorage.removeItem('changeableList');
    }
  },
  computed: {
    showRightPanel() {
      return Boolean(store.state.rightPanel.panelMode);
    },
    stageName() {
      const stage = store.state.candidate.selectedStage;
      return stage &&
        stage.fields[0] &&
        stage.fields[0].schema &&
        stage.fields[0].schema.stage_name
        ? stage.fields[0].schema.stage_name.text ||
            stage.fields[0].schema.stage_name
        : 'неизвестно';
    },
    selectedVacancyCandidate() {
      return store.state.vacancy.currentVacancyCandidate || null;
    },
    selectedEvent: {
      get() {
        return (
          store.state.candidate.selectedMeeting || {
            hrpac_candidate_id: this.fields.id
          }
        );
      },
      set(val) {
        store.commit('candidate/setSelectedMeeting', val);
      }
    },
    fields() {
      return store.state.candidate.metadata?.bean || {};
    },
    dialogVisible() {
      return store.state.dialog.singleDialogVisible;
    },
    dialogMetaData() {
      return store.state.dialog.dialogData || {};
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    selectedStage() {
      return store.state.candidate.selectedStage || null;
    },
    containerRef() {
      return this.$refs.container?.children[0]?.clientWidth;
    }
  },
  methods: {
    closeDeleteEventDialog() {
      this.is_visible.delete_event_dialog = false;
      this.deleteEventOptions = null;
    },
    deleteEvent() {
      eventBus.$emit(EVENTBUS_EVENTS.DELETE_EVENT);
      this.$set(this.is_visible, 'delete_event_dialog', false);
    },
    checkAuth() {
      eventBus.$emit(EVENTBUS_EVENTS.CHECK_PUBLICATOR_AUTH);
    },
    deleteDocument() {
      this.closeDialog('document_dialog');
      eventBus.$emit('deleteDocument');
    },
    closeAndUpdate(val) {
      this.editTableColumnsOptions = null;
      store.commit('common/setVisibleDialog', {
        name: 'table_edit_dialog',
        val: false
      });
      eventBus.$emit('closeAndUpdate', val);
    },
    onResize() {
      if (!this.containerRef) return;

      const widthPage = window.innerWidth;
      const isLeftPanelFixed =
        JSON.parse(localStorage.getItem('navMenu')) !== null;

      if (
        !isLeftPanelFixed &&
        widthPage < 1592 &&
        this.$refs['nav-panel'].isOpen
      ) {
        eventBus.$emit('closeMenu');
      } else if (
        !isLeftPanelFixed &&
        widthPage >= 1592 &&
        !this.$refs['nav-panel'].isOpen
      ) {
        eventBus.$emit('openMenu');
      }
      // const containerWidth = this.containerRef;
      // this.emptyWidth =
      //   widthPage -
      //   containerWidth -
      //   (this.rightPanelIsOpen ? 320 : 0) -
      //   (this.navPanelIsOpen ? 320 : 0);
      //
      // if (this.emptyWidth >= 320) {
      //   if (!this.rightPanelIsOpen) {
      //     eventBus.$emit('openRightPanel');
      //     this.rightPanelIsOpen = true;
      //     this.emptyWidth -= 320;
      //   }
      //   if (this.emptyWidth >= 320) {
      //     eventBus.$emit('openMenu');
      //     this.navPanelIsOpen = true;
      //   }
      // } else {
      //   if (this.emptyWidth + 320 > 0) return;
      //   eventBus.$emit('closeMenu');
      //   this.navPanelIsOpen = false;
      //   if (this.rightPanelIsOpen && this.emptyWidth < 320) {
      //     store.commit('rightPanel/setParam', {
      //       name: 'panelMode',
      //       val: null
      //     });
      //     this.rightPanelIsOpen = false;
      //     this.emptyWidth += 320;
      //   }
      // }
    },
    closeCurrentDialog(name) {
      store.commit('common/setVisibleDialog', {
        name: name,
        val: false,
        params: []
      });
      store.commit('dialog/setLoading', false);
    },
    async mergeDublicate() {
      const intent = {
        intentArea: 'Popup',
        intentType: 'confirm',
        module: 'HRPAC_CANDIDATES_DUPLICATES',
        request: {
          url: '/index.php?module=HRPAC_CANDIDATES_DUPLICATES&action=mergeDuplicateToCandidate',
          request_params: {
            parent_id: this.$route.params.id,
            duplicate_id: this.$route.params.dublicateId
          }
        },
        size: 'S'
      };
      try {
        store.commit('dialog/setLoading', true);
        const { data } = await mixin.methods.sendFormRequestFromIntent(intent);
        if (data.intents?.length) {
          const record =
            data.intents?.[0]?.request?.request_params?.record ??
            this.$route.params.id;
          this.$router.push({ name: 'candidateId', params: { id: record } });
        }
        if (data?.status == 'error') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: data?.error?.error_text?.error || 'Ошибка',
            duration: 6500,
            type: 'error'
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        store.commit('dialog/setLoading', false);
      }
    },
    async changeStage(intents, dialogName) {
      if (intents?.length) {
        for (let i = 0; i < intents.length; i++) {
          if (intents[i].intentArea == INTENT_AREA.AJAX) {
            let url = intents[i].request.url;

            for (let key in intents[i].request?.request_params) {
              url += `&${key}=${intents[i].request.request_params[key]}`;
            }

            try {
              const response = await getController({
                url
              });

              if (
                response?.status == 200 &&
                dialogName == 'general_dialog'
                // &&
                // this.stageName == 'Оффер'
              ) {
                this.parse();
              }

              if (
                response?.data?.errors &&
                Array.isArray(response.data.errors) &&
                response?.data?.errors?.length > 0
              ) {
                for (let i = 0; i < response.data.errors.length; i++) {
                  this.catchError({}, response.data.errors[i]);
                }
              } else if (
                response?.data?.status &&
                response?.data?.errors?.title &&
                response?.data?.status == 'error'
              ) {
                this.catchError({}, response.data.errors.title);
              } else {
                if (
                  this.$route.meta.module == MODULE.VACANCY_MODULE &&
                  this.$route.params.id
                ) {
                  if (this.selectedVacancyCandidate) {
                    //при смене этапа кандидата из карточки вакансии
                    //меняем данные этапа в выбранном кандидате
                    const tableData =
                      store.state.common.tableData?.vacancy_candidates?.rows;
                    let neededRow = null;
                    for (let i in tableData) {
                      if (
                        tableData[i]['ID'] !=
                        this.selectedVacancyCandidate['ID']
                      ) {
                        continue;
                      } else {
                        neededRow = tableData[i];
                        neededRow['CURRENT_STAGE_NAME'] = this.stageName;
                        neededRow['CURRENT_STAGE_ID'] =
                          this.selectedVacancyCandidate['ID'];
                        this.$set(
                          store.state.common.tableData?.vacancy_candidates
                            ?.rows,
                          i,
                          neededRow
                        );
                        break;
                      }
                    }
                    //если мы переводим кандидата на этап "Принят",
                    //то обновляем кол-во позиций в метаданных вкладки Описание,
                    //если они уже были загружены
                    if (
                      this.stageName == 'Принят' &&
                      store.state.subpanels.activeSubpanelData.hasOwnProperty(
                        'description'
                      )
                    ) {
                      let positionCount =
                        store.state.subpanels.activeSubpanelData.description
                          .metadata.top_custom_panels.amount_final.value;
                      store.state.subpanels.activeSubpanelData.description.metadata.top_custom_panels.amount_final.value =
                        (Number(positionCount) - 1).toString();
                    }
                    store.commit('vacancy/setParam', {
                      name: 'currentVacancyCandidate',
                      val: this.selectedVacancyCandidate
                    });
                  }
                }
                if (
                  intents[i].request.url.includes(
                    'generateCoordinationLogicFromStage'
                  ) &&
                  response.data?.result === 'success'
                ) {
                  this.showNotification({
                    offset: 100,
                    showClose: true,
                    message: 'Резюме отправлено на согласование',
                    duration: 6500,
                    type: 'success'
                  });
                }
              }
              store.commit('common/setVisibleDialog', {
                name: dialogName,
                val: false
              });
              store.commit('dialog/setLoading', false);
              store.commit('common/setRemoveGeneralDialog');
            } catch (err) {
              this.catchError(
                err,
                err || 'Возникла ошибка при переводе на этап'
              );
            }
          } else if (intents[i].intentArea == INTENT_AREA.RIGHT_PANEL) {
            store.dispatch('rightPanel/getMetadata', {
              intentOrRequest: intents[i].request
            });
          } else if (intents[i].intentArea == INTENT_AREA.DYNAMIC_PAGE) {
            if (intents[i].request?.request_params?.module == 'HRPAC_VACANCY') {
              const id = intents[i].request?.request_params?.record || '';
              store.dispatch('vacancy/getMetadata', id);
            }
          }
        }
      } else {
        store.commit('common/setVisibleDialog', {
          name: 'general_dialog',
          val: false
        });
        store.commit('dialog/setLoading', false);
      }
    }
  },
  components: {
    NavigationVue,
    RightPanel,
    SingleGeneralDialog,
    GeneralDialog,
    Dialog,
    CandidateImportTypeDialog,
    CandidateImportDialog,
    MassSaveResumeProgressDialog,
    EventEditDialog,
    ConfirmCloseDialog,
    PushNotifications,
    CoordinationPlanDialog,
    CoordinationPlanEditDialog,
    TableColumnsEditDialog,
    AuthDialog,
    CommonDialog,
    PublicatorAuthDialog,
    EmailDialog
  }
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  height: 100%;
  box-sizing: border-box;

  .main-container {
    width: 100%;
    min-width: 872px;
    max-width: 1600px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 24px 0;
    position: relative;
    height: calc(100% - 48px);
    margin: 0 auto;
    height: 100vh;
  }
}

@media (max-width: 1312px) {
  .app-wrapper > .main-container {
    margin-left: 96px;
  }
}
.no-right-panel {
  margin-right: 24px;
}
</style>
